type ValidateFn<TParams> = (params: TParams) => Promise<{ exists: boolean }>;

export function useKeyValidator<TParams>(validateFn: ValidateFn<TParams>) {
  const validate = async (params: TParams): Promise<string | null> => {
    try {
      const { exists } = await validateFn(params);
      return exists ? 'Такой ключ уже используется' : null;
    } catch {
      return 'Ошибка при проверке ключа';
    }
  };

  return { validate };
}
